export default [
  {
    path: '/wallets',
    name: 'wallets',
    component: () => import('@/views/wallets/Index.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Portefeuilles Fournisseurs',
      roles: ['admin', 'superadmin', 'accountant'],
      breadcrumb: [
        {
          text: 'Portefeuilles',
          active: true,
        },
      ],
    },
  },
  {
    path: '/wallets/show/:id',
    name: 'wallet-show',
    component: () => import('@/views/wallets/Show.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Détails Portefeuille',
      roles: ['admin', 'superadmin', 'accountant'],
      breadcrumb: [
        {
          text: 'Portefeuilles',
          to: { name: 'wallets' },
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
    },
  },
  {
    path: '/wallets/transactions',
    name: 'wallet-transactions',
    component: () => import('@/views/wallets/Transactions.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Transactions',
      roles: ['admin', 'superadmin', 'accountant'],
      breadcrumb: [
        {
          text: 'Portefeuilles',
          to: { name: 'wallets' },
        },
        {
          text: 'Transactions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/wallets/transactions/:id',
    name: 'transaction-show',
    component: () => import('@/views/wallets/TransactionDetail.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Détails Transaction',
      roles: ['admin', 'superadmin', 'accountant'],
      breadcrumb: [
        {
          text: 'Transactions',
          to: { name: 'wallet-transactions' },
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
    },
  },
  // Supplier's own wallet view
  {
    path: '/my-wallet',
    name: 'my-wallet',
    component: () => import('@/views/wallets/SupplierWallet.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Mon Portefeuille',
      roles: ['supplier'],
      breadcrumb: [
        {
          text: 'Mon Portefeuille',
          active: true,
        },
      ],
    },
  },
]
